import script from "./FieldsActions.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldsActions.vue?vue&type=script&setup=true&lang=js"

import "./FieldsActions.vue?vue&type=style&index=0&id=447a2aa2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-447a2aa2"]])

export default __exports__